// @ts-strict-ignore
import { ActionType } from 'flow/store/engine/constants';
import type { Action } from 'flow/store/engine/types';

import type { Attribute } from '~/flow/types';

import { OPERATORS } from './constants';

export function getThresholdOperatorString({
  action,
  attribute,
  operator,
}: {
  action: Action;
  attribute?: Attribute;
  operator: string;
}): string {
  if (action.type === ActionType.TAG || action.type === ActionType.OUTCOME_REASON) {
    return 'is';
  }
  if (attribute && attribute.dataType === 'reasoncodes') {
    return OPERATORS[`codes_${operator}`].text;
  }
  return OPERATORS[operator].symbol || OPERATORS[operator].text;
}
